import { z } from 'zod';

import { EmployeeWorkLetterType } from 'src/api';

import { FormFields } from './constants';
import { FormValues } from './types';

export const formValidationSchema = z.object({
  [FormFields.company]: z.object({
    id: z.string(),
    topLevelCompanyId: z.string(),
    employeeId: z.string(),
    feinValue: z.string(),
    displayName: z.string().nullable(),
    isPayrollsAvailable: z.boolean(),
    checksum: z.string(),
  }),
  [FormFields.letterType]: z.enum(EmployeeWorkLetterType),
}) satisfies z.ZodType<FormValues>;
